import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SliderPattern from '@mlb/react-patterns/components/Slider/slider.tsx';
import {
    Dot,
    Track,
} from '@mlb/react-patterns/components/Slider/slider.style.ts';

const Slider = styled(SliderPattern)`
    display: inline-block;
    width: 60px;
    margin-left: 15px;

    ${Dot} {
        width: 10px;
        height: 10px;
    }

    ${Track} {
        height: 3px;
    }
`;

const VolumeSlider = (props) => {

    let {
        mediaPlayer,
        volume,
        muted,
    } = props;

    const volumeValue = muted ? 0 : volume;

    return (
        <Slider
            defaultValues={[volumeValue]}
            minValue={0}
            maxValue={1}
            step={0.1}
            trackLeft={true}
            enableRailClick={true}
            enableTrackClick={true}
            handlers={{
                onUpdate: (value) => {

                    mediaPlayer.setVolume(value);

                    if (value > 0 && muted) {

                        mediaPlayer.unMute();

                    } else if (value <= 0 && !muted) {

                        mediaPlayer.mute();

                    }

                },
            }}
        />
    );

};

VolumeSlider.propTypes = {
    volume: PropTypes.number.isRequired,
    muted: PropTypes.bool.isRequired,
    mediaPlayer: PropTypes.object,
};

VolumeSlider.defaultProps = {
    mediaPlayer: {},
};

export default VolumeSlider;
